/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonCompanyDurationInfo
 */
export interface JsonCompanyDurationInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonCompanyDurationInfo
     */
    allowedActions?: Array<JsonCompanyDurationInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDurationInfo
     */
    companyDurationId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDurationInfo
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDurationInfo
     */
    durationId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDurationInfo
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyDurationInfo
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDurationInfo
     */
    userCount?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonCompanyDurationInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}

export function JsonCompanyDurationInfoFromJSON(json: any): JsonCompanyDurationInfo {
    return JsonCompanyDurationInfoFromJSONTyped(json, false);
}

export function JsonCompanyDurationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonCompanyDurationInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'companyDurationId': !exists(json, 'companyDurationId') ? undefined : json['companyDurationId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'durationId': !exists(json, 'durationId') ? undefined : json['durationId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'userCount': !exists(json, 'userCount') ? undefined : json['userCount'],
    };
}

export function JsonCompanyDurationInfoToJSON(value?: JsonCompanyDurationInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'companyDurationId': value.companyDurationId,
        'companyId': value.companyId,
        'durationId': value.durationId,
        'status': value.status,
        'title': value.title,
        'userCount': value.userCount,
    };
}

